import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { FC } from 'react';

import { medium } from '@styles/fontWeights';

type CannotFindPositionProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleBack: () => void;
};

const CannotFindPositionModal: FC<CannotFindPositionProps> = ({
  isOpen,
  handleClose,
  handleBack,
}) => {
  const handleGoBackClick = () => {
    handleBack();
    handleClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle
        color="primary.main"
        variant="h2"
        fontWeight={medium}
        sx={{ fontSize: '28px' }}
        component="p"
      >
        No problem!
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} textAlign="center">
          <Typography variant="h5" component="p" sx={{ fontSize: '18px' }}>
            First, make sure you’ve selected the correct industry for your
            needs. You can go back if you need to double check.
          </Typography>
          <Typography variant="h5" component="p" sx={{ fontSize: '15px' }}>
            If you still don’t see the position category you need, keep going
            and you can request the new position category inside your account.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={handleGoBackClick}
          color="secondary"
          variant="outlined"
        >
          Go Back
        </Button>
        <Button onClick={handleClose} color="primary" variant="outlined">
          Got It
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CannotFindPositionModal;
